module.exports = "<img [src]=\"image\">\n<h3>{{title}}</h3>\n<p>{{description}}</p>\n"